module.exports = __webpack_public_path__ + "static/intro-movie-web-small-18d6c6a4d20105408c6ec1060ffb97b5.mp4";